import Overview from './Overview';
import DetailedView from './DetailedView';

const ModelPerformance = {
  Overview,
  DetailedView,
};

export default ModelPerformance;
